import { API_URL } from "../constants/config";

export function courseMaterialUrl(id = 0, subId = 0, callbackUrl = false, isCertificate = false) {
    if (callbackUrl === false || id === 0) return false;
    const url  = `${API_URL}materials/course/${id}/${subId}` + (isCertificate === true ? '_cert' : '') + (callbackUrl ? `?callback=${API_URL}${callbackUrl}` : '');
    return url;
}

/* 
 *  TYPE : COURSE | EVENT | BUNDLE
 */ 
export function imageSrc(type, filename, paths) {
    /* LOCAL : 0 */
    const isServerStatus = API_URL.includes('local') || filename === '' || filename === 'default.jpg' ? 0 : 1;
    const image = {
        course : isServerStatus ? `${paths.course_path}${filename}` : paths.default_course,
        event  : isServerStatus ? `${paths.event_path}${filename}`  : paths.default_event,
        bundle : isServerStatus ? `${paths.bundle_path}${filename}` : paths.default_bundle,
        archive: isServerStatus ? `${paths.archive_path}${filename}` : paths.default_course,
        user   : isServerStatus ? `${paths.user_path}${filename}`   : paths.default_user,
    }
    return image[type];
}

export function isValidImageUrl(url) {
    if (!url) {
        return false;
    }
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.svg'];
    const lowerCaseUrl    = url.toLowerCase();
    return ((lowerCaseUrl.startsWith('http://') || lowerCaseUrl.startsWith('https://')) && imageExtensions.some(ext => lowerCaseUrl.endsWith(ext)));
}

export function capitalize(title, type = 'all') {
    /* ALL: EVERY FIRST CHARACTER || FIRST: ONLY FIRST CHARACTER */
    if (!title) {
        return false;
    }
    if (type !== 'all') {
        return title.charAt(0).toUpperCase() + title.slice(1)
    }
    const words = title.split(" ");
    for (let i = 0; i < words.length; i++) {
        words[i] = words[i][0].toUpperCase() + words[i].substr(1);
    }
    return words.join(" ");
}

/* ROLE 1: ADMIN | ROLE 2: LEARNER */
export function filterUrl(url, products, role = null, type='main') {
    if (!url) return false;

    let split, slug;
    split = url.split("/");
    split = split.filter((item) => item !== "");
    slug  = (type === 'main') ? split[split.length - 1] : split[split.length - 2];

    const map  = {
      "dms"    : "dms",
      "courses": "mykadmey",
      "bundles": "mykadmey",
      "events" : "tms",
    }

    const foundProduct = products.find((allowed) => allowed.sp_uid == map[slug]);

    if (foundProduct && new Date(foundProduct.expiry_date) > new Date()) {
        if (role !== null && foundProduct?.sp_disabled_roles && foundProduct?.sp_disabled_roles !== '' && foundProduct?.sp_disabled_roles !== null) {
            const disabledRoles = foundProduct?.sp_disabled_roles.includes(role);
            return disabledRoles;
        }
        return false;
    }
    
    return false;
}